// extracted by mini-css-extract-plugin
export default {"style2":"login_style2__+pdcM","style3":"login_style3__pDaip","form":"login_form__cMHQq","style4":"login_style4__WYxKp"};